import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  gender: belongsTo('category', { inverse: null }),
  positions: hasMany('category', { inverse: null }),
  sections: hasMany('section', { inverse: null }),
});
